import './cache-buster';

export default function loadChromecast() {
    try {
        if (!window.Chromecast) {
            return import('chromecastsender/chromecast').catch((e) => {
                console.warn('Error loading tn chromecast sender: ', e);
            });
        }
    } catch (e) {
        console.warn('Error loading chromecast sender: ', e);
    }

    return;
}
